import { createAsyncThunk } from "@reduxjs/toolkit";
import { URL_ORDERING_PRACTITIONERS } from "../../config/connString";
import useAxios from "../../utils/useAxios";
import decodedUserDetails from "utils/decodedUserDetails";

const updateOrderingPractitioner = createAsyncThunk(
  "ordering-practitioners/update-ordering-practitioner",
  async (data) => {
    try {
      const clientId = decodedUserDetails()?.clientId;
      const api = useAxios();

      const response = await api.put(URL_ORDERING_PRACTITIONERS, {
        id: data.id,
        firstName: data.firstName,
        lastName: data.lastName,
        clientId: clientId,
      });
      return response.data;
    } catch (error) {
      return error;
    }
  }
);

export { updateOrderingPractitioner };
